import { useState, useEffect } from 'react'


export function DetectLightDarkMode() {
    const [colourState, setColourState] = useState('dark')
    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => setColourState(e.matches ? 'dark' : 'light');

        mediaQuery.addEventListener('change', handleChange);

        // Setup dark/light mode for the first time
        setColourState(mediaQuery.matches ? 'dark' : 'light')

        // Remove listener
        return () => {
            mediaQuery.removeEventListener('change', handleChange);
        }
    }, []);
    return colourState
}

export function isDarkMode() {
    if (DetectLightDarkMode() === 'dark') { return true } else return false
}